import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SWITCH_STATE_ICON = {
  true: <i className="icon-checkmark text-primary size-16 d-block mx-0_25" aria-hidden />,
  false: <i className="icon-cross3 text-danger size-24 d-block" aria-hidden />,
};

export function SwitchState({ title, position, classname = null }) {
  return (
    <div
      className={classnames('h-100 d-flex align-items-center text-white text-capitalize', classname, {
        'justify-content-start': position === 'left',
        'justify-content-end': position === 'right',
      })}
    >
      {title}
    </div>
  );
}

SwitchState.propTypes = {
  title: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['left', 'right']).isRequired,
  classname: PropTypes.string,
};
